/**
 * MISSPOCA 貓爪游標
 * 定案：2026-05-23
 * 設計紀錄：vault PROJECTS/MISSPOCA官網_貓爪游標設計_2026-05-23.md
 *
 * 規則：
 *  - 桌機（hover: hover + pointer: fine）才啟用、手機不影響
 *  - prefers-reduced-motion 偵測、關閉 hover 循環動畫
 *  - 不擋表單輸入（input/textarea/contenteditable 仍是 text cursor）
 */
(function() {
  // 1. 手機 / 觸控裝置：不啟用
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  // 2. 建立 cursor DOM
  const cursor = document.createElement('div');
  cursor.className = 'cat-cursor';
  cursor.id = 'catCursor';
  cursor.setAttribute('aria-hidden', 'true');
  cursor.innerHTML = `
    <div class="cat-cursor-inner">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="32" height="32" style="overflow: visible;">
        <ellipse cx="39" cy="39" rx="11.5" ry="9" transform="rotate(-45 39 39)" fill="#FFFFFF" stroke="#000000" stroke-opacity="0.9" stroke-width="1.5"/>
        <g class="toe toe-1"><ellipse cx="17" cy="40" rx="4.1" ry="5.3" transform="rotate(-63 17 40)" fill="#FFFFFF" stroke="#000000" stroke-opacity="0.9" stroke-width="1.5"/></g>
        <g class="toe toe-2"><ellipse cx="19" cy="28" rx="4.1" ry="5.7" transform="rotate(-51 19 28)" fill="#FFFFFF" stroke="#000000" stroke-opacity="0.9" stroke-width="1.5"/></g>
        <g class="toe toe-3"><ellipse cx="28" cy="19" rx="4.1" ry="5.7" transform="rotate(-39 28 19)" fill="#FFFFFF" stroke="#000000" stroke-opacity="0.9" stroke-width="1.5"/></g>
        <g class="toe toe-4"><ellipse cx="40" cy="17" rx="4.1" ry="5.3" transform="rotate(-27 40 17)" fill="#FFFFFF" stroke="#000000" stroke-opacity="0.9" stroke-width="1.5"/></g>
      </svg>
    </div>
  `;
  document.body.appendChild(cursor);

  // 3. mousemove 跟手
  document.addEventListener('mousemove', function(e) {
    cursor.style.left = e.clientX + 'px';
    cursor.style.top  = e.clientY + 'px';
  });

  // 4. Hover 可點元素加 .hover class、觸發收爪循環
  //    用 event delegation、未來動態加入的元素也生效
  document.addEventListener('mouseover', function(e) {
    if (e.target.closest('a, button, [role="button"], .card, .product-card, .article-item, input[type="submit"], input[type="button"]')) {
      cursor.classList.add('hover');
    }
  });
  document.addEventListener('mouseout', function(e) {
    if (e.target.closest('a, button, [role="button"], .card, .product-card, .article-item, input[type="submit"], input[type="button"]')) {
      cursor.classList.remove('hover');
    }
  });

  // 5. 滑鼠離開視窗 = 隱藏 cursor
  document.addEventListener('mouseleave', function() { cursor.style.opacity = '0'; });
  document.addEventListener('mouseenter', function() { cursor.style.opacity = '1'; });

  // 6. 表單輸入元素 = 恢復原生 text cursor、避免影響打字
  document.addEventListener('focusin', function(e) {
    if (e.target.matches('input, textarea, [contenteditable]')) {
      cursor.style.opacity = '0';
    }
  });
  document.addEventListener('focusout', function(e) {
    if (e.target.matches('input, textarea, [contenteditable]')) {
      cursor.style.opacity = '1';
    }
  });
})();
